import { jsx as _jsx } from "react/jsx-runtime";
import { Data } from '../signup-data/DATA';
import { DataOptions } from '../signup-data/signupDataOptions';
import { BaseButtonsView } from './BaseButtonsView';

const CrmExperienceLevelView = () => {
  const options = DataOptions[Data.CrmExperienceLevel];
  return /*#__PURE__*/_jsx(BaseButtonsView, {
    options: options
  });
};

export default CrmExperienceLevelView;